// extracted by mini-css-extract-plugin
module.exports = {"item":"item--2Twss","label":"label--3r1HO","itemIcon":"itemIcon--2x_Vb","noBorderInput":"noBorderInput--3WnP6","action":"action--3LTwH","footer":"footer--2FIhg"};